import React, { useEffect, useState } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'
import styled from 'styled-components'

const TextLink = styled(Link)`
  text-decoration: none !important;

  &:hover {
    cursor: pointer !important;
  }
`

const MyFreebirdConditionalLink = ({
  linkUrl,
  accountStatus,
  subscriptionType,
  messageTrigger,
  forbiddenLinkClicked,
  children,
}) => {
  const [showLink, setShowLink] = useState(null)

  useEffect(() => {
    if (linkUrl) {
      if (subscriptionType === 'freemium') {
        if (linkUrl.includes('lp=events')) {
          setShowLink(false)
        } else {
          setShowLink(true)
        }
      } else {
        setShowLink(true)
      }
    } else {
      setShowLink(true)
    }
  }, [accountStatus])

  const triggerPopUp = (e) => {
    e.preventDefault()
    messageTrigger(true)
    forbiddenLinkClicked([true, linkUrl])
  }

  if (showLink) {
    if (linkUrl) {
      return <TextLink to={linkUrl}>{children}</TextLink>
    } else {
      return children
    }
  } else {
    return (
      <TextLink to={''} onClick={(e) => triggerPopUp(e)}>
        {children}
      </TextLink>
    )
  }
}

export default withRouter(withAuth(MyFreebirdConditionalLink))
